/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NumberList
 */
export interface NumberList {
    /**
     * E.g. list of ids of some entity or any other integer field
     * @type {Array<number>}
     * @memberof NumberList
     */
    i: Array<number>;
}

export function NumberListFromJSON(json: any): NumberList {
    return NumberListFromJSONTyped(json, false);
}

export function NumberListFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumberList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'i': json['i'],
    };
}

export function NumberListToJSON(value?: NumberList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'i': value.i,
    };
}


